module.exports = __webpack_public_path__ + "static/media/sort-grey.8e8be2ff.svg";